import { ulid } from "ulid";

/** Crockford base32 ULID — same shape data-feed accepts for `session_id`. */
const FINSTER_CHAT_SESSION_ID_PATTERN = /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/;

/**
 * Whether a persisted chat-tab id can be forwarded as Finster `session_id`.
 * Legacy opaque tab ids are kept for local history but must not be sent upstream.
 */
export function isFinsterChatSessionId(
  value: string | undefined | null
): value is string {
  return (
    typeof value === "string" &&
    FINSTER_CHAT_SESSION_ID_PATTERN.test(value.trim())
  );
}

/**
 * Create the stable identifier for a newly opened Office chat tab.
 *
 * Existing persisted tabs deliberately keep their opaque legacy identifiers;
 * only new sessions use the same sortable ULID shape as Finster web and task
 * sessions.
 */
export function createChatSessionId(): string {
  return ulid();
}
